/**
 * Único lugar que define "isto é uma tela de Home".
 *
 * O filtro de ativo pertence à Home — e só a ela. Antes, quem precisava dessa
 * noção a escrevia por exclusão (`!treeScreen && !resourceScreen`), o que é uma
 * dupla negação sobre dois sinalizadores que cada tela precisa lembrar de zerar.
 * Toda tela que não os zerava caía dentro da condição: os controles do filtro
 * chegavam a ser renderizados em Usuários, Logs, Perfil e na página de rota
 * inexistente. A regra vira positiva e mora num lugar só.
 *
 * Contam como Home todas as rotas sob `/home` — as três abas (Eventos, Alarmes,
 * Histórico) e os detalhes gerais.
 */
const HOME_PREFIX = "/home";

export function isHomeRoute(pathname) {
  if (typeof pathname !== "string") return false;
  return pathname === HOME_PREFIX || pathname.startsWith(`${HOME_PREFIX}/`);
}

export default isHomeRoute;
